module.exports = {
	"1": {
		"type": "question",
		"name": "Douane",
		"character": "Douan Yé",
		"characterImg": "douanye.png",
		"placeImg": "maison1.png",
		"bio": "Fan de littérature, il a lu toutes les œuvres de Jean-Jacques Rousseau et connaît par cœur les chansons de la Compagnie Créole.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/douanye.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Après un long voyage sans sommeil, vous débarquez enfin à Pékin. Très fatigué, vous vous présentez devant Douan Yé qui, après avoir contrôlé votre passeport, vous demande si vous avez quelque chose à déclarer&nbsp;:",
		"answers": [
			{
				"answer": "Tel un moine boudhiste, vous restez zen et lui répondez courtoisement que vous n’avez rien à déclarer",
				"win": "+1",
				"text": "Votre self-control vous permet de passer la douane sans encombres. Vous pouvez récupérer vos bagages et poursuivre votre route.",
				"goTo": "2"
			},
			{
				"answer": "Vous bégayez quelques mots pour lui signifier que vous êtes un bon citoyen (mais pourvu qu’il ne regarde pas dans votre valise...)",
				"win": "-1",
				"text": "Vous avez passé l'obstacle du douanier mais vous constatez que la compagnie aérienne a perdu vos bagages avec tout l'argent liquide que vous aviez caché dedans...",
				"goTo": "2"
			},
			{
				"answer": "Véxé qu'il ne vous ait pas reconnu, vous le prenez à partie pour lui rappeler qui est la star dans cet aéroport",
				"win": "0",
				"text": "Quelle arrogance&nbsp;! Il va falloir vous expliquer devant la police.",
				"goTo": "3"
			}
		]
	},
	"2": {
		"type": "question",
		"name": "Salle de presse",
		"character": "Miko Fon",
		"characterImg": "miko.png",
		"placeImg": "maison2.png",
		"bio": "Après avoir reçu le prix Poo Lee Zer, il devient rédacteur en chef du journal Li Kip où il couvre au quotidien l’actualité de la Chinese Super League.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/mikofon.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Direction les installations de votre nouveau club où doit se tenir votre première conférence de presse. Plusieurs centaines de journalistes vous y attendent dont Miko Fon qui vous interroge sur les raisons de votre venue en Chine. Vous avez appris par coeur votre première déclaration et vous déclamez haut et fort&nbsp;:",
		"answers": [
			{
				"answer": "我来到中国，把我家人的安全",
				"win": "0",
				"text": "Mettre votre famille à l'abri&nbsp;? Votre honnêteté vous honore mais vous n'êtes pas très respectueux des supporters. Vous ferez mieux la prochaine fois...",
				"goTo": "4"
			},
			{
				"answer": "我来中国体育的挑战",
				"win": "-1",
				"text": "Le challenge sportif&nbsp;? Sérieusement&nbsp;? Personne n'est dupe et votre hypocrisie ne passe pas inaperçue. Les ventes de vos maillots ne décollent pas...",
				"goTo": "4"
			},
			{
				"answer": "我不知道中国足球超级联赛，但她知道我",
				"win": "+1",
				"text": "Vous ne connaissez pas la Chinese Super League mais elle vous connaît&nbsp;? Cela vexe les bien-pensants mais les supporters se ruent en boutique acheter votre maillot.",
				"goTo": "4"
			}
		]
	},
	"3": {
		"type": "question",
		"name": "Poste de police",
		"character": "Seï Lul",
		"characterImg": "seilul.png",
		"placeImg": "maison3.png",
		"bio": "Aimable comme une porte de prison, il cherche à tout prix à prendre la clé des champs et à s'évader au grand air. Il passe son temps libre devant les rediffusions de Fort Boyard.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/seilul.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Votre esclandre à l'aéroport vous conduit directement en garde à vue. Les choses ne s'annoncent pas très bien pour vous mais heureusement, vous tombez sur Seï Lul, le flic le plus corrompu de Pékin qui vous propose un arrangement...",
		"answers": [
			{
				"answer": "Ne souhaitant pas que l'affaire s'ébruite, son prix sera le vôtre",
				"win": "-1",
				"text": "Si le silence n'a pas de prix, celui de Seï Lul vaut son pesant d'or. Après vous êtes acquitté de votre dû, vous pouvez rejoindre votre club.",
				"goTo": "2"
			},
			{
				"answer": "Sentant l'arnaque, vous refusez mais proposez de faire des excuses publiques lors d'une conférence de presse",
				"win": "-2",
				"text": "Après d'âpres négociations, vous parvenez à quitter le poste de police sans perdre d'argent mais la rumeur de votre garde à vue s'ébruite et déclenche immédiatement le retrait de l'un de vos sponsors.",
				"goTo": "2"
			},
			{
				"answer": "Hors de question&nbsp;! Vous n'êtes pas venu en Chine pour vous faire racketter&nbsp;!",
				"win": "0",
				"text": "La sanction est immédiate&nbsp;: Seï Lul interdit votre entrée sur le territoire et met un terme à votre carrière chinoise. Retour à la case départ, il est temps de trouver un nouvel eldorado.",
				"goTo": "end"
			}
		]
	},
	"4": {
		"type": "chance",
		"name": "Fortune Cookie",
		"character": "Taï Ming",
		"characterImg": "taiming.png",
		"placeImg": "chance2.png",
		"bio": "Intendant du club depuis 20 ans, il accueille les nouveaux joueurs depuis le réveil du football chinois. Il n'hésite pas à sonner l'alarme à leur moindre coup de barre.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/taiming.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Vous voilà maintenant installé et il est temps de vous rendre à votre premier entraînement. Mais vous n'aviez pas pensé aux embouteillages... Arriverez-vous à l'heure&nbsp;?",
		"answers": [
			{
				"answer": "",
				"win": "+1",
				"text": "Bien joué, pour votre premier entrainement, votre idée d'abandonner la voiture pour le vélo était la bonne. Vos nouveaux coéquipiers vous attendent dans le vestiaire pour vous offrir des cadeaux de bienvenue dont le montant total s'avère un vrai jackpot&nbsp;!",
				"goTo": "5"
			},
			{
				"answer": "",
				"win": "-1",
				"text": "Pas de chance, vous n'avez pas su prendre les raccourcis pour éviter les embouteillages et arrivez avec plus de 30mn de retard à votre premier d'entrainement... Votre statut de star n'y changera rien, vous écopez d'une amende. Vous ferez attention la prochaine fois&nbsp;!",
				"goTo": "5"
			}
		]
	},
	"5": {
		"type": "question",
		"name": "Salon de coiffure",
		"character": "Bro Ching",
		"characterImg": "brushing.png",
		"placeImg": "maison5.png",
		"bio": "Finaliste du championnat du monde de la coupe au bol 2008, grand fan de Tokio Hotel, il est le coiffeur officiel du club. Il est de mèche avec le président pour ne pas dégrader l'ambiance du club.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/broching.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "La saison est sur le point de commencer et, tel Balotelli, vous souhaitez marquer les esprits par votre choix capillaire. Vous prenez donc rendez-vous avec Bro Ching, le coiffeur du club. La coupe, c'est pas qu'en fin de saison.",
		"answers": [
			{
				"answer": "Fan des années 90, le mulet Vairelles sera du plus bel effet",
				"win": "+1",
				"text": "Dès votre sortie du salon, vous êtes pris en photo et finissez en couverture de Beijing Match. Votre coupe fait fureur auprès des jeunes et vous permet de signer un contrat avec Tête & Epaules.",
				"goTo": "6"
			},
			{
				"answer": "Premiers cheveux blancs, la teinture dorée à la Cissé camouflera tout ça",
				"win": "0",
				"text": "Teinture dorée + Chine = fracture du tibia et du péroné assurée... Votre aventure chinoise se termine sur cette sale blessure. Mais restez positif, vous pourrez toujours poursuivre votre carrière au Qatar ou à la Réunion.",
				"goTo": "end"
			},
			{
				"answer": "Du Jul dans les oreilles, évidemment la crête à la Ménez",
				"win": "-1",
				"text": "Votre nouvelle coupe de cheveux devient rapidement la risée des réseaux sociaux et des coiffeurs du monde entier, allant jusqu'à vous faire perdre votre contrat avec Tête & Epaules.",
				"goTo": "6"
			}
		]
	},
	"6": {
		"type": "question",
		"name": "Bijouterie",
		"character": "Les frères Bling",
		"characterImg": "bling.png",
		"placeImg": "maison6.png",
		"bio": "Jumeaux monozygotes, les bijoux sont pour eux une histoire de famille. Ils ont également dessiné le trophée de la Chinese Super League.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/bling.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Votre relooking ne va pas s'arrêter là&nbsp;? Vous devez mettre tous les atouts de votre côté pour leur en mettre plein les yeux. Direction la bijouterie des frères Bling pour trouver la joaillerie idoine. Evidemment, vous optez pour la plus voyante...",
		"answers": [
			{
				"answer": "Un disque Bi en émeraude",
				"win": "0",
				"text": "Très bon choix, ce disque Bi est du plus bel effet autour de votre cou. C'est sûr que vous allez faire un carton dans les pages people des magazines.",
				"goTo": "7"
			},
			{
				"answer": "Un Maneki Neko en rubis",
				"win": "+1",
				"text": "Quelle audace&nbsp;! Votre goût du kitch fait un tabac auprès des autres joueurs du vestiaire qui se ruent chez les frères Bling. Pour vous remercier, ils vous offrent un second bijou de forte valeur.",
				"goTo": "7"
			},
			{
				"answer": "Les Fu Lu Shou en saphir",
				"win": "-1",
				"text": "Aïe aïe aïe, l'addition s'avère très salée. En plus, vous vous rendez compte que les pierres précieuses... ne le sont pas. Quelle arnaque&nbsp;!",
				"goTo": "7"
			}
		]
	},
	"7": {
		"type": "question",
		"name": "Stade",
		"character": "Maï Yo",
		"characterImg": "maiyo.png",
		"placeImg": "maison7.png",
		"bio": "Ancien samouraï reconverti dans le foot, il débute sa carrière à Dijon avant de revenir en Chine. Il est très proche des joueurs avec qui il organise souvent des barbecues.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/maiyo.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Enfin le grand jour&nbsp;! Vous jouez votre premier match sous vos nouvelles couleurs mais, à court de forme, vous passez totalement à travers. Votre entraineur, Maï Yo, s'agite sur le banc de touche et vous sort dès la 60ème minute...",
		"answers": [
			{
				"answer": "Incontrôlable, vous vous dirigez vers votre entraîneur pour l'insulter, vous n'êtes pas venu en Chine pour être remplacé&nbsp;!",
				"win": "0",
				"text": "Humilié en public, votre entraîneur réclame votre tête. La mayonnaise n'ayant jamais pris avec le reste de l'équipe, le président vous renvoie sans chichis.",
				"goTo": "end"
			},
			{
				"answer": "Conscient de votre manque de forme, vous ne lui en tenez pas rigueur et regagnez le banc sans broncher",
				"win": "+1",
				"text": "Généreux, votre président décide de doubler votre prime de match afin de vous motiver à poursuivre vos efforts.",
				"goTo": "8"
			},
			{
				"answer": "Furieux, vous quittez le terrain sans saluer votre entraîneur et vos coéquipiers et regagnez immédiatement le vestiaire",
				"win": "-1",
				"text": "Votre réaction ne passe pas auprès de votre président qui décide de vous rappeler qui est le patron en vous infligeant une lourde amende.",
				"goTo": "9"
			}
		]
	},
	"8": {
		"type": "question",
		"name": "Vestiaire",
		"character": "Gol Ri",
		"characterImg": "golri.png",
		"placeImg": "maison8.png",
		"bio": "Président du fan club chinois de Michel Leeb, il a été recruté pour débrider le vestiaire et faciliter l’intégration des joueurs étrangers.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/golri.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Malgré votre prestation, le premier match de votre équipe se solde par une victoire. De retour au vestiaire, vos coéquipiers en profitent pour vous bizuter et Gol Ri, le fanfaron du vestiaire, vous oblige à pousser la chansonnette. Vous êtes fan de karaoké, vous êtes en pleine confiance et chantez la première chanson qui vous passe par la tête&nbsp;:",
		"answers": [
			{
				"answer": "“Et moi et moi et moi” de Jacques Dutronc",
				"win": "-1",
				"text": "Personne ne comprenant le français, votre prestation fait chou blanc. Pour mieux communiquer avec vos coéquipiers, vous décidez de prendre des cours de langue.",
				"goTo": "10"
			},
			{
				"answer": "“Mille Colombes” de Mireille Mathieu",
				"win": "-1",
				"text": "Vous vouliez bien faire en reprenant la chanson d'une star en Chine mais vous aviez oublié que c'était il y a plus de 30 ans... Votre prestation fait un bad buzz sur les réseaux sociaux, vous faisant perdre votre contrat avec Doozer.",
				"goTo": "10"
			},
			{
				"answer": "“Nan Ni Wan”, une chanson traditionnelle chinoise",
				"win": "+1",
				"text": "Votre prestation, filmée par vos coéquipiers, dépasse rapidement les 100M de vues, vous permettant de signer un juteux contrat avec Doozer.",
				"goTo": "10"
			}
		]
	},
	"9": {
		"type": "question",
		"name": "Parking",
		"character": "Hoo Lee",
		"characterImg": "hoolee.png",
		"placeImg": "maison9.png",
		"bio": "Leader du SINO (Supporters Inconditionnels et Notoirement Optimistes), le stade est son défouloir. Sans chichis, il aime mettre son grain de sel et mener les chants à la baguette.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/hoolee.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Malgré la victoire de votre équipe, les supporters ne retiennent que votre attitude au moment de votre remplacement. Un groupe d'ultras, Hoo Lee à leur tête, attend à la sortie du stade pour vous faire part de leur mécontentement. La confrontation est imminente...",
		"answers": [
			{
				"answer": "Vous ne vous arrêtez pas pour leur parler, après tout vous n'avez aucun compte à leur rendre",
				"win": "-1",
				"text": "La nouvelle de votre comportement se répand rapidement et provoque un boycott immédiat des maillots floqués à votre nom.",
				"goTo": "10"
			},
			{
				"answer": "Vous vous arrêtez pour leur signifier votre volonté de faire mieux au prochain match",
				"win": "+1",
				"text": "Votre abnégation fait remonter votre cote auprès des supporters qui se précipitent dans les boutiques du club pour acheter votre maillot.",
				"goTo": "10"
			},
			{
				"answer": "Vous descendez de votre voiture pour lui mettre un coup de boule, si Zidane l'a fait, pourquoi pas vous&nbsp;?",
				"win": "0",
				"text": "Vous auriez dû le savoir, Zidane n'est pas le héros de la finale de 2006... vous suivez le même chemin que lui et quittez la Chine tête baissée mais toujours le poing levé.",
				"goTo": "end"
			}
		]
	},
	"10": {
		"type": "chance",
		"name": "Fortune Cookie",
		"character": "Tro Fey",
		"characterImg": "trofey.png",
		"placeImg": "chance2.png",
		"bio": "Président de la Ligue Chinoise depuis 15 ans et grand fan de Rodin. Son superbe bronze lui a fait gagner la médaille d'argent au concours de la Pêche d'Or.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/trofey.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Déjà 2 mois que le championnat a commencé et c'est l'heure des premières récompenses individuelles. Quelle sera la vôtre&nbsp;?",
		"answers": [
			{
				"answer": "",
				"win": "+1",
				"text": "Vous êtes élu joueur du mois. Et une bonne nouvelle n'arrivant jamais seule, vous repartez également avec une jolie prime et une voiture de luxe offerte par le sponsor officiel de la League&nbsp;!",
				"goTo": "11"
			},
			{
				"answer": "",
				"win": "-1",
				"text": "Vous voilà élu joueur moisi du mois. Une mauvaise nouvelle en entrainant une autre, ce trophée actionne automatiquement une clause de votre contrat revalorisant votre salaire à la baisse.",
				"goTo": "11"
			}
		]
	},
	"11": {
		"type": "question",
		"name": "Salle de soins",
		"character": "Kin Yé",
		"characterImg": "kinye.png",
		"placeImg": "maison2.png",
		"bio": "Pointure de l'acupuncture chinoise, il est le médecin du club où il y a inventé une chaussure orthopédique révolutionnaire&nbsp;: la chaussure de Marcos.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/kinye.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "À la veille de votre premier classico, vous vous claquez à l'entraînement. Le diagnostic de Kin Yé, médecin du club, est sans appel, vous serez indisponible au moins 3 semaines. La guigne, il y avait une petite prime à récupérer...",
		"answers": [
			{
				"answer": "Vous relativisez, après tout, 3 semaines de vacances vous feront du bien",
				"win": "0",
				"text": "C'est depuis les tribunes que vous assistez à la victoire de votre équipe qui vous permet de prendre la tête du championnat. Rien de tel qu'une petite soirée avec vos équipiers pour fêter ça&nbsp;!",
				"goTo": "12"
			},
			{
				"answer": "Compétiteur dans l'âme, vous décidez de jouer quand même, sans oublier de prendre quelques antalgiques",
				"win": "-2",
				"text": "Il n'aura pas fallu 10mn pour que vous demandiez le remplacement à votre entraineur, la douleur étant trop insupportable. Vous ne le savez pas encore mais vous venez d'empirer votre blessure, vous obligeant à aller consulter un grand spécialiste chinois.",
				"goTo": "13"
			},
			{
				"answer": "Obstiné mais prudent, vous demandez à être sur la feuille pour rentrer en cours de match",
				"win": "+1",
				"text": "Lancé à la 75ème minute alors que le score est à égalité, vous claquez le but de la victoire dans les arrêts de jeu. Pour vous féliciter, votre président triple votre prime de match et invite l'équipe à fêter cela comme il se doit.",
				"goTo": "12"
			}
		]
	},
	"12": {
		"type": "question",
		"name": "Boîte de nuit",
		"character": "Albert Kohl",
		"characterImg": "albertkhol.png",
		"placeImg": "maison3.png",
		"bio": "International allemand tout juste divorcé. Grand fan de Georges Best, il est toujours dans les bons plans pour arroser ses coéquipiers à base de Tsingtao.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/albertkohl.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Après avoir fait la tournée des bars, vous finissez la nuit au Dao Club avec quelques coéquipiers. Parmi eux, l'allemand Albert Kohl, jamais le dernier pour faire la fête et dépasser les limites. Vous décidez de le suivre en&nbsp;:",
		"answers": [
			{
				"answer": "Vous faisant un petit rail, vous avez toujours voulu ressembler au Pibe de Oro",
				"win": "-2",
				"text": "Vous avez pris cher lors de cette soirée et vous ne vous rappelez pas comment vous avez atterri dans cette chambre d'hôtel... mais que s'est-il donc bien passé&nbsp;?",
				"goTo": "14"
			},
			{
				"answer": "Mélangeant tous les alcools, si Paul Gascoigne l'a fait pourquoi pas vous&nbsp;?",
				"win": "-1",
				"text": "Vous avez pris cher lors de cette soirée et vous ne vous rappelez pas comment vous avez atterri dans cette chambre d'hôtel... mais que s'est-il donc bien passé&nbsp;?",
				"goTo": "14"
			},
			{
				"answer": "En dégustant un bon spliff comme Bernard Lama",
				"win": "-1",
				"text": "Vous avez pris cher lors de cette soirée et vous ne vous rappelez pas comment vous avez atterri dans cette chambre d'hôtel... mais que s'est-il donc bien passé&nbsp;?",
				"goTo": "14"
			}
		]
	},
	"13": {
		"type": "question",
		"name": "Clinique privée",
		"character": "Do Ping",
		"characterImg": "doping.png",
		"placeImg": "maison4.png",
		"bio": "Toujours positif à l'insu de son plein gré, il est conseiller spécial de la Fédération Russe d’Athlétisme et mentor des docteurs Fuentes et Ferrari.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/doping.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Pour tenter de soigner cette vilaine blessure, vous acceptez de traverser le pays pour aller rencontrer Do Ping, grand guérisseur tibétain. Après qu'il vous ait manipulé, plusieurs options se présentent à vous&nbsp;:",
		"answers": [
			{
				"answer": "Rien de mieux que la médecine traditionnelle, laissez-vous tenter par un peu d'acupuncture&nbsp;!",
				"win": "-1",
				"text": "Votre (Bruno) bélonéphobie prend le dessus et vous ne parvenez pas à soigner cette blessure. Encore un mois loin des terrains...",
				"goTo": "12"
			},
			{
				"answer": "Une transfusion de sang de yak et vous allez retrouver toute votre force&nbsp;!",
				"win": "+1",
				"text": "Votre retour surprise à la compétition se solde par un quadruplé et un carton rouge. Ça valait bien un nouveau contrat avec Red Burnn et une soirée arrosée avec vos coéquipiers.",
				"goTo": "12"
			},
			{
				"answer": "Les méthodes de M. Ping paraissent bien louches, ne vous laissez pas avoir&nbsp;!",
				"win": "0",
				"text": "C'était votre dernière chance de vous rétablir. Votre blessure vous empêche de poursuivre votre carrière et signe votre retour à la maison.",
				"goTo": "end"
			}
		]
	},
	"14": {
		"type": "chance",
		"name": "Fortune Cookie",
		"character": "Ri Berri",
		"characterImg": "riberri.png",
		"placeImg": "chance2.png",
		"bio": "D’origine sino-française, elle s'est faite connaître dans le remake chinois de Scarface qui lui ouvre la porte des soirées mondaines dans lesquelles elle chine de nombreux joueurs de football.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/riberri.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "",
		"answers": [
			{
				"answer": "",
				"win": "-2",
				"text": "...Vous avez fini la nuit avec Ri Berri, escort très appréciée des footballeurs. Mais vous ne saviez pas qu'elle avait tout filmé avec son téléphone... Pas de chance, un de vos coéquipiers met la main dessus et vous fait chanter pour ne pas la dévoiler à la presse.",
				"goTo": "15"
			},
			{
				"answer": "",
				"win": "0",
				"text": "...Vous avez fini la nuit avec Ri Berri, escort très appréciée des footballeurs. Mais vous ne saviez pas qu'elle avait tout filmé avec son téléphone... C'est votre jour de chance, elle perd son téléphone en se rendant à son prochain rendez-vous.",
				"goTo": "15"
			}
		]
	},
	"15": {
		"type": "question",
		"name": "Casino",
		"character": "Bon Di Manh Chow",
		"characterImg": "bandimancho.png",
		"placeImg": "maison6.png",
		"bio": "Cul de jatte suite à un <a href=\"http://www.p2j.fr/\" target=\"_blank\">passement de jambes</a> raté, elle est croupière la nuit et tient un blog de nail art le jour.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/bondimanhchow.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Après votre mésaventure de l'hôtel, vous décidez de vous détendre un peu. Direction le casino où vous vous retrouvez à la roulette avec des russes. Après quelques parties, vous décidez de tout miser sur un dernier numéro.",
		"answers": [
			{
				"answer": "5",
				"win": "0",
				"text": "Vous auriez dû savoir que le 5 était le numéro du maillot de Franck Dumas. Comme lui, vous perdez tout votre argent au casino et vous partez vous réfugier en Guinée pour échapper à la justice...",
				"goTo": "end"
			},
			{
				"answer": "15",
				"win": "+1",
				"text": "C'est votre première partie de roulette et tel Bernard Mendy, vous faites un grand pont et débordez la croupière&nbsp;! On vous en reparlera dans 10 ans.",
				"goTo": "16"
			},
			{
				"answer": "25",
				"win": "+1",
				"text": "Après avoir gagné au Black Jack, vous signez un doublé comme Marvin Martin lors de sa première sélection. Dites donc cette petite ukrainienne serait pas en train de vous mater&nbsp;?",
				"goTo": "16"
			}
		]
	},
	"16": {
		"type": "question",
		"name": "Banque",
		"character": "Lee Vréa",
		"characterImg": "leevrea.png",
		"placeImg": "maison7.png",
		"bio": "Conseiller financier proche de Jacques Kachkar, il est toujours en action, à l'affût des bonnes opportunités du marché. Il est également adepte des plages nudistes où il aime être à découvert.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/leevrea.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Vous avez dorénavant un peu d'argent sur votre NEM (Nouvel Enregistrement Monétaire), il est temps de l’investir. Vous prenez rendez-vous avec votre banquier qui vous présente plusieurs opportunités. Vous vous laissez séduire par&nbsp;:",
		"answers": [
			{
				"answer": "Les piscines Guy Vrache",
				"win": "+1",
				"text": "Votre associé s'avère être un homme discret mais à qui tout réussi. Il gagne des contrats sans même se pointer aux rendez-vous. Il ne vous en fallait pas plus pour rentabiliser votre investissement.",
				"goTo": "17"
			},
			{
				"answer": "Les restaurants Flo Rièze",
				"win": "0",
				"text": "Votre associé s'avère être un homme fourbe. Juste avant de signer le contrat, il s'en va fricoter avec un autre investisseur, vous laissant sur le carreau. Au moins, vous n'avez pas lâché votre oseille.",
				"goTo": "18"
			},
			{
				"answer": "Les instituts de beauté Dee Hue",
				"win": "-1",
				"text": "Votre associé s'avère être un véritable meneur d'hommes. Après s'être impliqué dans le lancement de l'affaire, il se fait la malle dans l'institut de beauté d'en face avec tous ses petits secrets. Un investissement raté.",
				"goTo": "18"
			}
		]
	},
	"17": {
		"type": "question",
		"name": "Garage",
		"character": "Tu Ning",
		"characterImg": "tuning.png",
		"placeImg": "maison8.png",
		"bio": "Introverti, numéro 2 du concours international Mario Kart 2002, il sort de sa carapace pour ouvrir son propre garage automobile qui devient vite un succès grâce à sa banane légendaire.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/tuning.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Fort de vos succès sur le terrain et dans les affaires, vous décidez de vous faire un petit cadeau et d'améliorer votre voiture. C'est vrai, ce reportage sur le tuning portugais vous a vraiment inspiré. C'est certain, votre caisse sera tellement plus belle avec&nbsp;:",
		"answers": [
			{
				"answer": "Un volant Momo, simple et efficace",
				"win": "0",
				"text": "Mouais, bof... Le style est au rendez-vous mais un volant Momo sérieusement&nbsp;? Accrochez le sapin senteur boisé sur le pare-brise tant que vous y êtes...",
				"goTo": "19"
			},
			{
				"answer": "Des néons verts sous le chassis, la classe",
				"win": "+1",
				"text": "C'était un choix audacieux mais qui s'avère payant. Vous êtes reconnu dans toute la ville et les paparazzi vous shootent à tout va. Et bim les procès pour atteinte à la vie privée qui tombent et l'oseille qui va avec&nbsp;!",
				"goTo": "19"
			},
			{
				"answer": "Un intérieur full zèbre, votre côté animal",
				"win": "-1",
				"text": "Grossière erreur. Votre goût pour les safaris vous vaut des réprimandes de toutes les associations de protection animale. Vous voilà contraint de dégainer le chéquier pour faire des dons afin acheter votre tranquilité. Vous êtes le dindon de la farce.",
				"goTo": "19"
			}
		]
	},
	"18": {
		"type": "question",
		"name": "Agence de marketing",
		"character": "Spon Söring",
		"characterImg": "sponsoring.png",
		"placeImg": "maison9.png",
		"bio": "Self-made-man né à Orange, il débute sa carrière comme livreur chez Domino’s Pizza puis comme vendeur chez Conforama. Mais c’est en Chine qu’il prospère en conseillant les grandes fortunes chinoises.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/sponsoring.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Vos derniers investissements n'ont pas porté leurs fruits et vous êtes dans l'obligation d'accepter un nouveau contrat publicitaire pour vous refaire. Votre conseiller image vous propose de choisir parmi ces 3 marques&nbsp;:",
		"answers": [
			{
				"answer": "Le Slip Chinois",
				"win": "+1",
				"text": "Qu'on se le dise, Cristiano Ronaldo n'est pas le seul à savoir jongler en slip moulant. Votre publicité fait un tabac chez la jeunesse chinoise qui s'arrache vos slips mais vous rhabille pour l'hiver.",
				"goTo": "17"
			},
			{
				"answer": "BlaBlaPoussePousse",
				"win": "+1",
				"text": "En devenant l'égérie de la marque, vous donnez un vrai coup de pouce aux réservations qui explosent. Le concept fait un carton auprès des jeunes pousses chinoises et vous rapporte un joli pactole.",
				"goTo": "17"
			},
			{
				"answer": "Le Bon Chien",
				"win": "-1",
				"text": "Mais quelle idée d'associer votre image à celui d'un site de rencontre pour animaux&nbsp;! La publicité où l'on vous voit à 4 pattes devient la risée des réseaux sociaux. Il va vous falloir donner un coup de collier pour rattraper tout ça.",
				"goTo": "19"
			}
		]
	},
	"19": {
		"type": "chance",
		"name": "Fortune Cookie",
		"character": "Carjack Ing",
		"characterImg": "carjacking.png",
		"placeImg": "chance2.png",
		"bio": "Ancien maraîcher en prunes et champignons, il décide de mettre le turbo en passant dans le vol de voiture. Pour le moment il est toujours passé à travers les radars de la police.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/carjacking.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "",
		"answers": [
			{
				"answer": "",
				"win": "0",
				"text": "De retour d'un entraînement, vous êtes arrêté au feu quand soudain un malfrat vous attaque. Par chance, l'homme est un grand fan et vous reconnaît immédiatement, vous laissant partir tranquillement.",
				"goTo": "20"
			},
			{
				"answer": "",
				"win": "-2",
				"text": "De retour d'un entraînement, vous êtes arrêté au feu quand soudain un malfrat vous attaque. Pas de chance, l'homme vous reconnaît et, en plus de votre voiture, décide de vous dépouiller de tous vos biens précieux. Bye bye la montre, les bijoux et le cash.",
				"goTo": "20"
			}
		]
	},
	"20": {
		"type": "question",
		"name": "Agence de voyage",
		"character": "Herr Franz",
		"characterImg": "her_franz.png",
		"placeImg": "maison2.png",
		"bio": "Agent d’escale de première classe, il n'économise pas ses efforts pour décoller dans le business. Le low cost est sa hantise.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/herrfranz.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "C'est enfin la trêve hivernale&nbsp;! Suite aux bons résultats du club, le président offre à tous les joueurs une semaine de vacances. Il est venu le temps de&nbsp;:",
		"answers": [
			{
				"answer": "Rentrer au pays pour voir la famille et les amis",
				"win": "-1",
				"text": "Si vous êtes généreux sur le terrain, vous l'êtes aussi dans la vraie vie. Vous profitez ainsi de votre retour au bled pour aider financièrement les cousins, les oncles et tous les voisins...",
				"goTo": "21"
			},
			{
				"answer": "Rester en Chine, histoire de mieux connaître le pays",
				"win": "+1",
				"text": "Vos vacances dans un petit village de la province de Guizhou ont ému des millions de chinois mais aussi le marketing de Ginette qui vous choisit comme nouvel ambassadeur de la marque. Un joli coup de Guizhou&nbsp;!",
				"goTo": "22"
			},
			{
				"answer": "Aller vous reposer aux Caraïbes avec votre moitié",
				"win": "-1",
				"text": "Pour rester loin des paparazzi, vous décidez de privatiser Necker Island au cœur des Caraïbes. Votre moitié appréciera, votre banquier un peu moins...",
				"goTo": "21"
			}
		]
	},
	"21": {
		"type": "question",
		"name": "Cabinet de psy",
		"character": "Anna Lyse",
		"characterImg": "wurst.png",
		"placeImg": "maison3.png",
		"bio": "Jeune diplomée grâce à sa fraude aux examens écrits, elle dépasse le stade de l'oral et devient conseillère matrimoniale en Asie. Son père était là quand il a fallu s'intégrer à la vie chinoise.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/annalyse.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Pendant vos vacances, votre moitié trouve des textos coquins sur votre portable. Votre mariage bat de l'aile. Pour tenter de le sauver, vous acceptez de vous allonger sur le divan.",
		"answers": [
			{
				"answer": "Vous avouez tout et allez même jusqu'à parler de la sextape",
				"win": "-10",
				"text": "Vos remords et vos excuses n'y changeront rien, votre moitié réussit à obtenir le divorce et à partir avec une partie de votre fortune.",
				"goTo": "22"
			},
			{
				"answer": "Vous préférez nier et prenez la décision de rompre avec votre maîtresse",
				"win": "-2",
				"text": "Si vous parvenez à reconquérir le cœur de votre moitié grâce à ce mensonge, votre maîtresse en revanche accepte très mal la décision. Vous parvenez cependant à la ramener à la raison en achetant son silence.",
				"goTo": "22"
			},
			{
				"answer": "Vous prétendez que c'est une mauvaise blague d’Albert Kohl",
				"win": "0",
				"text": "La réputation sulfureuse de votre coéquipier n'est plus un secret pour personne et votre moitié tombe facilement dans le panneau. Vous pourrez vivre la fin de saison plus sereinement.",
				"goTo": "22"
			}
		]
	},
	"22": {
		"type": "question",
		"name": "Soirée de gala",
		"character": "Berndt Hess",
		"characterImg": "berndthuss.png",
		"placeImg": "maison4.png",
		"bio": "Agent FIFA suisse romand, il adore le vin en pot. Après avoir berné plusieurs clubs européens, il se réfugie en Asie où il fait venir de nombreux joueurs.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/berndthess.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Lors d'une soirée caritative organisée par le club, vous surprenez votre agent Berndt Hess en train d’essayer de récupérer dans ses filets votre pire ennemi, Hank Huley. Vous ne vous laissez pas faire.",
		"answers": [
			{
				"answer": "Vous réglez ça entre hommes avec Hank, vous n'aimez pas le dialogue",
				"win": "0",
				"text": "Il ne fallait pas s'attaquer à l'Hank de Chine qui vous envoie au tapis en moins de deux. Humilié, vous quittez le pays dès le lendemain. Votre passage ne laissera pas un souvenir indélébile.",
				"goTo": "end"
			},
			{
				"answer": "Vous mettez un terme à votre collaboration, vous n'aimez pas les trahisons",
				"win": "-2",
				"text": "Malgré les tentatives de Berndt pour vous reconquérir, votre décision est définitive. Tout comme les indémnités que vous êtes obligé de lui verser pour la rupture de contrat.",
				"goTo": "23"
			},
			{
				"answer": "Vous mettez la pression à Berndt pour garder l'exclusivité, vous n'aimez pas partager",
				"win": "+1",
				"text": "Votre jalousie porte ses fruits puisque votre agent parvient à vous obtenir une revalorisation de contrat. Ce n'est pas cet Huley qui va vous la faire à l'envers.",
				"goTo": "23"
			}
		]
	},
	"23": {
		"type": "question",
		"name": "Plateau télé",
		"character": "Lucas Moulox",
		"characterImg": "moulox.png",
		"placeImg": "maison5.png",
		"bio": "Erotomane, il a tous les DVD de Questions pour un Champion. Star de la télé chinoise, il a demandé sa compagne en mariage au Japon.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/lucasmoulox.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Vous êtes invité à participer à l’émission phare de la télévision chinoise, La Ligue des Questions, animée par le séduisant Lucas Moulox. Vous arrivez à la dernière question pouvant faire gagner 1 million à l’association que vous défendez. Quel club a gagné le plus de fois la Chinese Super League&nbsp;?",
		"answers": [
			{
				"answer": "Dalian Chide",
				"win": "+1",
				"text": "La  Chinese Super League n'a déjà plus de secret pour vous&nbsp;! Avec 8 championnats à son palmarès, c'est bien le Dalian Shide qui est le plus titré, suivi du Guangzhou Evergrande (6). Le Shanghai SIPG n'a quant à lui encore jamais remporté le titre.",
				"goTo": "24"
			},
			{
				"answer": "Shanghai SIPG",
				"win": "0",
				"text": "Et non, bien qu'il soit l'un des clubs les plus actifs sur le marché des transferts, le Shanghai SIPG n'a encore jamais gagné le titre. Rappelons tout de même qu'il a été promu pour la première fois de son histoire à l'issue de l'année 2012&nbsp;!",
				"goTo": "24"
			},
			{
				"answer": "Guangzhou Evergrade",
				"win": "0",
				"text": "Vous n'êtes pas passé loin du million&nbsp;! Si le Guangzhou Evergrande a remporté les 6 derniers championnats, c'est le Dalian Shide qui est le club le plus titré de Chine. Leur dernier titre remonte déjà à 2005&nbsp;!",
				"goTo": "24"
			}
		]
	},
	"24": {
		"type": "question",
		"name": "Restaurant",
		"character": "No Nö",
		"characterImg": "nono.png",
		"placeImg": "maison6.png",
		"bio": "Patron du “Comptoir Malesherbes”, il paie ses shots de saké chemise ouverte et chaîne en or qui brille. Pas de pacotilles.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/nono.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Le grand Lucas Moulox vous convie à dîner au “Comptoir Malesherbes”, célèbre restaurant chinois aux airs de brasserie française, tenu par No Nö. À tous les coups, vous allez vous régaler ce soir. Mais le menu n’est pas traduit, alors au hasard vous choisissez&nbsp;:",
		"answers": [
			{
				"answer": "A4",
				"win": "0",
				"text": "Vous n'aviez pas vu que c'était une entrée et vous n'avez donc droit qu'à une simple soupe. Heureusement, cela vous permet d'écourter le diner avec Lucas Moulox qui n'a cessé de vous raconter ses histoires amoureuses.",
				"goTo": "25"
			},
			{
				"answer": "B2",
				"win": "0",
				"text": "Vous tombez sur le menu Baijiu, essentiellement composé d'alcools locaux. Pas de chance pour vous, No Nö vous déroule le tapis rouge et vous fait goûter à tous les breuvages, surtout les plus mauvais. Vous finissez au plus mal et loupez l'entrainement du lendemain.",
				"goTo": "25"
			},
			{
				"answer": "C1",
				"win": "0",
				"text": "Vous n'avez pas vu mais vous venez de commander le menu ogre. Heureusement, vous avez le temps de déguster tranquillement pendant que Lucas Moulox vous raconte toutes ses histoires amoureuses",
				"goTo": "25"
			}
		]
	},
	"25": {
		"type": "chance",
		"name": "Fortune Cookie",
		"character": "Ku Qi",
		"characterImg": "kuki.png",
		"placeImg": "chance2.png",
		"bio": "Superstitieux, il consulte son horoscope tous les jours et fréquente le même cercle astral que Doumé Nek. Veuf, il se rend tous les jours sur la stèle de Ni, sa femme.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/kuqi.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "",
		"answers": [
			{
				"answer": "",
				"win": "0",
				"text": "Vous arrivez à la fin du repas et le serveur, Ku, vous ramène un fortune cookie. Vous l'ouvrez et y lisez “La routourne va bientôt tourner”.",
				"goTo": "26"
			},
			{
				"answer": "",
				"win": "0",
				"text": "Vous arrivez à la fin du repas et le serveur, Ku, vous ramène un fortune cookie. Vous l'ouvrez et y lisez “Ne brûlez pas la peau de l’ours avant de l’avoir vendue”.",
				"goTo": "26"
			}
		]
	},
	"26": {
		"type": "question",
		"name": "Cabinet médical",
		"character": "Rocco Li",
		"characterImg": "roccoli.png",
		"placeImg": "maison8.png",
		"bio": "Diététicien, il raconte souvent des salades à ses patients, grâce à quoi il gagne beaucoup d’oseille. Malgré ses oreilles en chou-fleur et son physique d’asperge, il est aussi un grand séducteur.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/roccoli.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "C’est bientôt la fin de saison et vous avez pris quelques kilos... Cela va nuire et à vos résultats et à vos primes. Pour perdre ces kilos superflus, vous choisissez de&nbsp;:",
		"answers": [
			{
				"answer": "Suivre un régime Tao",
				"win": "+1",
				"text": "Bien vous en a pris de vous mettre à la culture chinoise. Le régime Tao que vous a conseillé Rocco Li vous fait perdre 5 kilos en quelques jours.",
				"goTo": "27"
			},
			{
				"answer": "Vous rendre à Merano",
				"win": "-2",
				"text": "Comme Zidane, Benzema ou Gignac, votre cure au Palace Merano en Italie porte ses fruits. Mais pour parvenir à perdre vos kilos en trop, votre portefeuille subira lui aussi une cure d'amaigrissement...",
				"goTo": "27"
			},
			{
				"answer": "Prendre des brûleurs de graisse",
				"win": "0",
				"text": "Mamadou Sakho vous avait pourtant prévenu, le brûleur de graisse que vous avez pris contient de l'higénamine. Reconnu coupable de dopage, vous êtes suspendu de toutes compétitions chinoises pendant 5 ans.",
				"goTo": "end"
			}
		]
	},
	"27": {
		"type": "question",
		"name": "Sélection",
		"character": "Doumé Nek",
		"characterImg": "doumenek.png",
		"placeImg": "maison9.png",
		"bio": "Après avoir insulté un usagé de “sale fils de p...”, il dit adieu à sa carrière de chauffeur de bus et se recycle dans le football. Il est aujourd’hui sélectionneur national où il court toujours après son premier trophée.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/doumenek.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Alors que personne ne s'y attendait, vous êtes appelé en sélection par Doumé Nek. Il reste 3 numéros de maillots disponibles. Vous choisissez&nbsp;:",
		"answers": [
			{
				"answer": "Le 3",
				"win": "-1",
				"text": "Tel Mickaël Ciani, vous passez totalement à côté de votre premier match en sélection. Vous êtes conspué par les supporters et lynché par la presse. Restez en Chine, c'est la meilleure solution pour vous faire oublier...",
				"goTo": "29"
			},
			{
				"answer": "Le 10",
				"win": "0",
				"text": "Tel Julien Faubert, vous rentrez à 20mn de la fin du match et offrez la victoire à votre sélection. Si vos débuts sont encourageants, votre retour en Chine signera pourtant la fin de votre carrière internationale.",
				"goTo": "28"
			},
			{
				"answer": "Le 14",
				"win": "+1",
				"text": "Tel un certain Zizou, vous rentrez en cours de jeu pour honorer votre première sélection et inscrivez 2 buts, permettant à votre pays d'arracher un match nul. Le début d'une longue histoire&nbsp;?",
				"goTo": "28"
			}
		]
	},
	"28": {
		"type": "question",
		"name": "Réseaux sociaux",
		"character": "Fesb Hook",
		"characterImg": "fesb_hook.png",
		"placeImg": "maison1.png",
		"bio": "Lanceur d’alerte qui se fait connaître suite au Football Leaks. Il est la hantise des joueurs de foot qu’il provoque régulièrement sur les réseaux sociaux.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/fesbhook.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "La fin de saison approche et pour ne pas laissez vos fans sans nouvelles jusqu'à la reprise, vous décidez de vous lancer sur les réseaux sociaux avec l'aide de Fesb Hook. Vous choissisez&nbsp;:",
		"answers": [
			{
				"answer": "Periscope",
				"win": "0",
				"text": "Alors que vous vous confiez à Fesb Hook sur la médiocrité du championnat chinois et le piètre talent de vos coéqupiers, celui-ci en profite pour tout filmer en direct. Vos excuses n'y changeront rien, vous êtes renvoyé du club.",
				"goTo": "end"
			},
			{
				"answer": "Instagram",
				"win": "-1",
				"text": "Si vos selfies devant le miroir ravissent vos fans, ceux pris pendant les entraînements énervent votre entraîneur et votre président qui vous mettent à l'amende.",
				"goTo": "29"
			},
			{
				"answer": "Twitter",
				"win": "+1",
				"text": "Tel Patman, vos clashs avec les journalistes chinois deviennent rapidement célèbres. Fernandel, Tournevis, Duarig et les autres n'ont qu'à bien se tenir.",
				"goTo": "29"
			}
		]
	},
	"29": {
		"type": "question",
		"name": "Radio",
		"character": "P2J",
		"characterImg": "p2j.png",
		"placeImg": "maison2.png",
		"bio": "Collectif de podcasteurs passionnés de football et de photos Instagram (pour certains), c'est le seul média à défendre la Ligue 1 et ses grandes affiches hebdomadaires.<br /><a href=\"http://www.p2j.fr/\" target=\"_blank\">www.p2j.fr</a><br /><a href=\"http://transfertsdepekin.fr/affiches-persos/p2j.png\" target=\"_blank\">Télécharger son affiche</a>",
		"question": "Pour la fin de saison chinoise, vous êtes invité à participer au podcast en vogue, Passement de Jambes. Après une excellente émission, l’équipe vous demande pourquoi avoir choisi de venir vous frotter à l'impertinence des chroniqueurs&nbsp;:",
		"answers": [
			{
				"answer": "Parce que ça existe depuis plus de 2 ans et que vous les écoutiez avant d’aller en Chine",
				"win": "+1",
				"text": "Vous finissez la saison en beauté avec cette excellente réponse. Il est temps de faire le bilan de cette année et de décider ce que vous allez faire la saison prochaine&nbsp;!",
				"goTo": "win"
			},
			{
				"answer": "Parce que ça parle bien de la Ligue 1 et que vous avez toujours adoré ce championnat",
				"win": "+1",
				"text": "Vous finissez la saison en beauté avec cette excellente réponse. Il est temps de faire le bilan de cette année et de décider ce que vous allez faire la saison prochaine&nbsp;!",
				"goTo": "win"
			},
			{
				"answer": "Parce que c’est une bande de potes et qu’ils parlent football sans tabous",
				"win": "+1",
				"text": "Vous finissez la saison en beauté avec cette excellente réponse. Il est temps de faire le bilan de cette année et de décider ce que vous allez faire la saison prochaine&nbsp;!",
				"goTo": "win"
			}
		]
	},
	"30": {
		"type": "question",
		"name": "Banque",
		"character": "Fiascao",
		"characterImg": "bankr_hoot.png",
		"bio": "Banquier colombien border line, il a toujours du nez pour blanchir de l'argent. Jamais sur la paille, il arrive à prende la poudre d'escampette avant chaque descente de flics.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/fiascao.png\" target=\"_blank\">Télécharger son affiche</a>"
	},
	"31": {
		"type": "question",
		"name": "Pays-Bas",
		"character": "Poot",
		"characterImg": "poot.png",
		"bio": "Fermière dans le Drenthe, elle passe son temps à vendre des tulipes sur le trottoir pour subvenir aux besoins de ses nombreux fils.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/poot.png\" target=\"_blank\">Télécharger son affiche</a>"
	},
	"32": {
		"type": "question",
		"name": "Maison",
		"character": "Mönik",
		"characterImg": "monik.png",
		"bio": "Mère poulpe, elle a votre nom tatoué à l’encre de Chine. Après une saison loin de vous, elle s’installe à vos côtés pour contrôler votre vie privée.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/monik.png\" target=\"_blank\">Télécharger son affiche</a>"
	},
	"33": {
		"type": "question",
		"name": "Cinéma",
		"character": "Monsieur Huk",
		"characterImg": "huk.png",
		"bio": "Footix, auteur de manga à succès, il se reconvertit dans les films tendancieux et se fait connaître pour son premier film “Les Geishas d’à côté”.<br /><a href=\"http://transfertsdepekin.fr/affiches-persos/monsieurhuk.png\" target=\"_blank\">Télécharger son affiche</a>"
	}
};


//////////////////
// WEBPACK FOOTER
// ./data/questions.json
// module id = 17
// module chunks = 0